/****************************************************
 * Module Name:  appStart.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Login from "./login/login";
import PageBody from "./home/pageBody";
import Constants from "./../utility/constants";
import UserPermissionProxy from "../utility/proxy/manager/permissionProxy/userPermissionProxy";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import Utility from "../utility/utility";
import { Box, CircularProgress, Typography } from "@mui/material";
import UserColumnPermissionProxy from "../utility/proxy/manager/permissionProxy/userColumnPermissionProxy";
import SettingsProxy from "../utility/proxy/manager/settingsProxy";
import StoneTypeProxy from "../utility/proxy/manager/stoneTypeProxy";

export class AppStart extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      initialLogin: false,
      userToken: "",
    };

    const { cookies } = props;
    let cookieExist = cookies.getAll();

    if (
      cookieExist.loggedInUser !== undefined &&
      new Date(cookieExist.loggedInUser.expires) >= new Date() &&
      cookieExist.userToken !== undefined &&
      Utility.ParseAndGetJWTExpTime(cookieExist.userToken) >= ((Date.now() / 1000) + 1) //+1 second for buffer
    ) {
      this.onSuccessLogin(cookieExist.loggedInUser, cookieExist.userToken);
    }
  }

  onSuccessLogin = (loggedInUser, userToken) => {
    const { cookies } = this.props;
    UserPermissionProxy.GetSingleUserPermission(
      [loggedInUser.id],
      userToken,
      (response) => {
        try {
          if (response) {
            this.setState({
              initialLogin: true,
              userToken: userToken,
            });
            let lExpires = Constants.COOKIE_EXPIRES();
            loggedInUser.expires = lExpires;

            Constants.loggedInUser = loggedInUser;
            Constants.userToken = userToken;

            Constants.USER_PERMISSION = response;

            cookies.set("loggedInUser", JSON.stringify(loggedInUser), {
              path: "/",
              expires: lExpires,
            }); // setting the cookie
            cookies.set("userToken", JSON.stringify(userToken), {
              path: "/",
              expires: lExpires,
            }); // setting the cookie

            this.getColumnPermissionsForUser();
            this.getStoneTypeMapping();
            this.getNewStoneDaysSetting();
            this.getColumnPermissions();
          } else {
            return;
          }
        } catch (error) {

        }
      }
    );
  };

  getNewStoneDaysSetting = () => {
    try {
      SettingsProxy.GetSettingsByName(["NEW_STONE_DAYS"], (response) => {
        if (response) {
          Constants.NEW_STONE_DAYS = response[0].settingvalue;
        } else return;
      });
    } catch (error) {

    }
  }

  getStoneTypeMapping = () => {
    try {
      StoneTypeProxy.GetAllStoneTypeByDisabled(false, (response) => {
        if (response) {
          let stonetype = {};
          response.map(iStoneType => {
            stonetype = { ...stonetype, [iStoneType.name]: iStoneType.fullname }
            return true;
          })
          Constants.STONE_TYPE = stonetype;
          Constants.uniqueFilterValues.stonetype = response;
        } else return;
      });
    } catch (error) {

    }
  }

  getColumnPermissionsForUser = () => {
    try {
      UserColumnPermissionProxy.GetPermissionsForUserInSequence(Constants.loggedInUser.id, (response) => {
        if (response) {
          Constants.USER_COLUMN_PERMISSION = response;
        } else return;
      });
    } catch (error) {

    }
  };

  getColumnPermissions = () => {
    try {
      UserColumnPermissionProxy.GetAllColumnPermissionMap((response) => {
        if (response) {
          Constants.COLUMN_PERMISSION = response;
        } else return;
      });
    } catch (error) {

    }
  };

  onLogout = () => {
    let lExpires = Constants.COOKIE_EXPIRES();
    const { cookies } = this.props;
    cookies.remove("loggedInUser", {
      path: "/",
      expires: lExpires,
    });
    cookies.remove("userToken", {
      path: "/",
      expires: lExpires,
    });
    Utility.ReloadSite(window.location.origin);
  };

  render() {
    const { cookies } = this.props;
    let cookieExist = cookies.getAll();
    if (cookieExist.loggedInUser !== undefined &&
      new Date(cookieExist.loggedInUser.expires) >= new Date() &&
      cookieExist.userToken !== undefined &&
      Utility.ParseAndGetJWTExpTime(cookieExist.userToken) >= ((Date.now() / 1000) + 1) && !this.state.initialLogin) {
      return (
        <Box width={'100%'} height={'100vh'} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} >
          <CircularProgress color="primary" size='100px' />
          <Typography mt={1}>Loading ...</Typography>
        </Box>)
    }
    return (
      <Box>
        {!this.state.initialLogin ? (
          <Login
            onSuccess={(loggedInUser, userToken) =>
              this.onSuccessLogin(loggedInUser, userToken)
            }
          />
        ) : (
          <PageBody onLogout={() => this.onLogout()} />
        )}
      </Box>
    );
  }
}

export default withCookies(AppStart);
